/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

// Componentes
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';
import Notifications from "react-notifications-menu";

// Icons
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
// import MailIcon from '@mui/icons-material/Mail';

// Componentes.
import Search from '../search/Search';
import SearchIconWrapper from '../search/SearchIconWrapper';
import StyledInputBase from '../search/StyledInputBase';
import BellIcon from '../../assets/icons/bell-regular-24.png';
import msgNotificacion from '../../scripts/notification';
import ModalCambioContrasena from '../modal/CambioContrasena';

//
import '../profile/profile.css';

// Redux
import { useDispatch } from 'react-redux';
import { showProgress } from '../../redux/reducers/progress.Slice';
import { ROLES_PERMITIDOS } from '../../redux/constants';

// Services
import EmpleadoService from '../../services/empleadoService';
import HomeService from '../../services/homeService';

const Profile = ({ mostrarSidebar }) => {
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = useState(null)
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null)
  const isMenuOpen = Boolean(anchorEl)
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)
  const userLogin = JSON.parse(localStorage.getItem('user'))
  const [dataFilter, setDataFilter] = useState([])  
  const [dataNotifications, setDataNotifications] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [userName, setUserName] = useState(userLogin?.NombreUsuario)

  // Función para mostrar el loading
  // Se utiliza para mostrar el loading en la pantalla
  const setLoading = (value) => {
    try {
      dispatch(showProgress(value))
    } catch (error) {
      console.error(error)
    }
  }

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    try {
      setAnchorEl(null)      
    } catch (error) {
      console.error(error)
    }
  }

  const handlePerfil = () => {
    try {
      window.location.href = '/miPerfil';
    } catch (error) {
      console.error(error)
    }
  }

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    try {
      setTimeout(() => {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('user')

        window.location.href = "/";
      }, 500)

      dispatch(showProgress(true))
    } catch (error) {
      console.error(error)
    }
  }

  const handleChange = async (value) => {
    try {
      if (!value) {
        setDataFilter([])
        return
      }

      if (!ROLES_PERMITIDOS.includes(userLogin.CodigoRol))
        return

      const data = {
        Name: value,
      }

      await getEmpleados(data)
    } catch (error) {
      console.error(error)
    }
  }

  const getEmpleados = async (employedFilter) => {
    try {
      EmpleadoService.getDatosCboSolicitud()
      .then((response) => {
          if (!response) {
            console.error('Error de conexión con la API, consulte al administrador del sitio.')
            return
          }

          if (response.Codigo === 1) {
            const data = response?.Data?.Empleados
            const dataEmpleado = data?.filter(item => item.label.includes(employedFilter.Name.toUpperCase()) && item.label.trim() !== 'TODOS')

            if (dataEmpleado?.length === 0) {
              const dataEmpleadoCodigo =  data?.filter(item => item.id.includes(employedFilter.Name.toUpperCase()) && item.label.trim() !== 'TODOS')

              if (dataEmpleadoCodigo?.length === 0)
                setDataFilter([{ id: 'EM00000', label: 'Sin resultados...' }])
              else
                setDataFilter(dataEmpleadoCodigo)
            } else {
              setDataFilter(dataEmpleado)
            }
          } else {
            setDataFilter([{ id: '', label: 'Sin resultados...' }])
          }
      })
      .catch((error) => {
        console.error('error', error)
      })
    } catch (error) {
      console.error(error)
    }
  }

  const getNotifications = async (data) => {
    try {
      HomeService.getNotifications(data)
      .then((response) => {
          if (!response) {
            console.error('Error de conexión con la API, consulte al administrador del sitio.')
            return
          }

          if (response.Codigo === 1) {
            const dataResponse = response.Data.map(item => ({
              image: item.image,
              message: item.message,
              detailPage: item.detailPage,
              receivedTime: calculaTiempoTranscurrido(item.receivedTime)
            }))
            
            setDataNotifications(dataResponse)
          } else {
            setDataNotifications([])
          }
      })
      .catch((error) => {
        console.error('error', error)
      });
    } catch (error) {
      console.error(error)
    }
  }

  const calculaTiempoTranscurrido = (fechaNotificacion) => {
    try {
      const ahora = new Date();
      const fechaPasada = new Date(fechaNotificacion.slice(0,19));
      const diferencia = ahora - fechaPasada; // Diferencia en milisegundos

      if (isNaN(diferencia)) {
          return "Fecha inválida";
      }

      const segundos = Math.floor(diferencia / 1000);
      const minutos = Math.floor(segundos / 60);
      const horas = Math.floor(minutos / 60);
      const días = Math.floor(horas / 24);

      if (días > 0) return `Hace ${días} día(s)`;
      if (horas > 0) return `Hace ${horas} hora(s)`;
      if (minutos > 0) return `Hace ${minutos} minuto(s)`;

      return `Hace ${segundos} segundo(s)`;
    } catch (error) {
      console.error(error)
    }
  }

  const searchEmployed = (data) => {
    try {
      if (!data) return

      localStorage.setItem('empleadoSelected', data?.id)

      window.open('/miPerfil', '_blank_')
    } catch (error) {
      console.error(error)
    }
  }

  const handleOnFocus = (e) => {
    try {      
      e.target.select()
    }catch (error) {
      console.error(error)
    }
  }

  const handleCardOption = async (message, isAll) => {
    try {
      let idNotificacion = 0

      if (message)
        idNotificacion = (obtenerCaracterAntes(message, '.'))

      const dataRequest = {
        id: parseInt(idNotificacion),
        isAll: isAll,
        codEmpleado: userLogin.CodigoEmpleado
      }
      
      await readNotifications(dataRequest)
    } catch (error) {
     console.error(error)
    }
  }

  function obtenerCaracterAntes(texto, caracter) {
    // Encontrar la posición del caracter específico
    const indice = texto.indexOf(caracter);
    
    // Si el caracter no se encuentra o está al principio, retornar null
    if (indice === -1) {
        return null;
    }
    
    // Retornar el carácter anterior
    return texto.slice(0, indice);
  }

  const readNotifications = async (data) => {
    try {
      HomeService.readNotifications(data)
      .then((response) => {
          if (!response) {
            console.error('Error de conexión con la API, consulte al administrador del sitio.')
            return
          }

          if (response.Codigo === 1) {
            msgNotificacion('Marcado como leída', 'success', 1000)
            getNotifications(data)
          } else {
            msgNotificacion(response.Mensaje, 'error')
          }
      })
      .catch((error) => {
        console.error('error', error)
      });
    } catch (error) {
      console.error(error)
    }
  }

  const handleChangePassword = () => {
    try {
      setOpenModal(true)
      setUserName(userLogin.NombreUsuario)
      
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    try {
      const data = {
        codEmpleado: userLogin.CodigoEmpleado
      }

      getNotifications(data)
    } catch (error) {
      console.error(error)
    }
  }, [])

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handlePerfil}>Mi perfil</MenuItem>
      <MenuItem onClick={handleChangePassword}>Cambiar contraseña</MenuItem>
      <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
      >      
      <MenuItem className='align-items-end justify-content-start ps-0 pb-0' onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Perfil</p>
      </MenuItem>
      <MenuItem className='align-items-end justify-content-start ps-0 pb-0'>
        <IconButton
          size="large"
          aria-label="show 10 new notifications"
          color="inherit"
        >
          <Badge badgeContent={dataNotifications?.length} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notificaciones</p>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1, position: 'sticky', zIndex: 1000, top: 0}}>
      <ModalCambioContrasena
        setOpenModal={setOpenModal}
        openModal={openModal}
        usuario={userName}
        setLoading={setLoading}
      />

      <AppBar className='bg-danger' position='sticky'>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            onClick={() => mostrarSidebar()}
          >
            <MenuIcon />
          </IconButton>
          <Search
            onChange={(e) => handleChange(e.target.value)}
            onFocus={(e) => handleOnFocus(e)}
            //quitar auto completar
            autoComplete='off'
            className='search'
            >
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder='Buscar empleado...'
              inputProps={{ 'aria-label': 'search', 'autoComplete': 'off' }}              
            />
            <div className='div-list-search'>
            {
              dataFilter?.map((item, props) => {
                return (
                  <Box
                    {...props}
                    key={item.id}
                    className='lst-search'
                    component="li"
                    sx={{ '& > img': { mr: 1, flexShrink: 0 } }}
                    onClick={() => searchEmployed(item)}
                  >
                    <h6 className='text-white my-1 w-100 lst-search-fontSize' key={item.id}>{item.id} - {item.label}</h6>
                  </Box>
                )
              })
            }
            </div>
          </Search>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex', alignItems: 'center' } }}>
            <Notifications
              data={dataNotifications}
              icon={BellIcon}
              cardOption={data => handleCardOption(data.message, false)}
              headerBackgroundColor = '#dc3545'
              header={{
                title: "Notificaciones",                
                option: { text: "Eliminar todas", onClick: () => handleCardOption(null, true) }
              }}              
            />

            <Tooltip title='Abrir perfil'>
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
            </Tooltip>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
}

export default Profile;